(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

/** Turnstile lifecycle for the classic guest checkout. Server validation is authoritative. */
(function ($) {
  'use strict';

  var widgetId = null;
  var container = null;

  function clearToken() {
    if (container) {
      container.querySelectorAll('[name="cf-turnstile-response"]').forEach(function (input) {
        input.value = '';
      });
    }
  }

  function renderOrReset(reset) {
    var next = document.getElementById('quvent-turnstile-checkout');
    var api = window.turnstile;
    var config = window.quventTurnstile;
    if (!api || !config || !config.siteKey) return;

    if (container !== next) {
      clearToken();

      if (widgetId !== null) {
        try {
          api.remove(widgetId);
        } catch (error) {
          /* Woo may have already removed the fragment. */
        }
      }

      widgetId = null;
      container = next;
    }

    if (!container) return;

    if (widgetId !== null) {
      if (reset) {
        clearToken();
        api.reset(widgetId);
      }

      return;
    }

    widgetId = api.render(container, {
      sitekey: config.siteKey,
      theme: config.theme || 'light',
      appearance: config.appearance,
      action: 'quvent_checkout',
      'expired-callback': function expiredCallback() {
        clearToken();
      },
      'error-callback': function errorCallback() {
        clearToken();
      }
    });
  }

  $(function () {
    if (window.turnstile) window.turnstile.ready(function () {
      renderOrReset(false);
    });
    $(document.body).on('updated_checkout', function () {
      renderOrReset(true);
    }); // A token may already have been consumed before another checkout validation fails.

    $(document.body).on('checkout_error', function () {
      renderOrReset(true);
    });
    $(window).on('pageshow', function () {
      renderOrReset(true);
    });
  });
})(jQuery);

},{}]},{},[1]);
